import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmartPhone = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 14,
		height: 20,
		x: 5,
		y: 2,
		rx: 2,
		ry: 2,
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 18h.01",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2
	})]
});
export default SvgSmartPhone;
